export default "__VITE_ASSET__Dbxk_s_0__"